import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VuexPersistence from 'vuex-persist'

Vue.use(Vuex)

import session from './modules/session'
import banners from './modules/banners'
import { messaging } from '@/plugins/firebase'

const persistence = new VuexPersistence()

export default new Vuex.Store({
  state: {
    loading: false,
    http: null,
    firebaseMessagingInstance: null,
    notification: {
      title: null,
      text: null,
      persistence: 6000
    }
  },
  getters: {},
  mutations: {
    setLoading(state, value) {
      state.loading = value
    },
    startHttp(state) {
      state.http = axios.create({
        baseURL: process.env.VUE_APP_USA_URL,
        headers: { 'Content-Type': 'application/json' }
      })
    },
    showNotification(state, params) {
      state.notification.title = params.title
      state.notification.text = params.text || null
      state.notification.persistence =
        params.persistence || state.notification.persistence

      setTimeout(() => {
        this.commit('hideNotification')
      }, state.notification.persistence)
    },
    hideNotification(state) {
      state.notification.title = null
      state.notification.text = null
      state.notification.persistence = 6000
    }
  },
  actions: {
    async request({ commit, state }, params) {
      let body = params.body
      const result = {
        status: false,
        data: null
      }

      if (!state.http) commit('startHttp')

      if (params.method === 'get') {
        body = { params: params.body }
      }

      let res = null
      try {
        if (params.baseUrl) {
          res = await state.http[params.method](
            params.baseUrl + params.url,
            body
          )
        } else {
          res = await state.http[params.method](params.url, body)
        }
        // eslint-disable-next-line no-empty
      } catch (e) {}

      if (res && res.status === 200) {
        result.status = true
        result.data = res.data
      }

      return result
    },
    async initializeFirebaseMessaging({ state }) {
      state.firebaseMessagingInstance = await messaging
    }
  },
  modules: {
    session,
    banners
  },
  plugins: [persistence.plugin]
})
